import { Link } from 'react-router-dom';

const footerLinks = {
  explore: [
    { href: '/', label: '首页' },
    { href: '/category/all', label: '电影分类' },
    { href: '/category/action', label: '动作片' },
    { href: '/category/comedy', label: '喜剧片' },
    { href: '/category/scifi', label: '科幻片' },
  ],
  support: [
    { href: '/about', label: '关于我们' },
    { href: '/about', label: '联系我们' },
    { href: '/about', label: '用户口碑' },
  ],
  categories: [
    { href: '/category/romance', label: '爱情片' },
    { href: '/category/suspense', label: '悬疑片' },
    { href: '/category/animation', label: '动画片' },
    { href: '/category/war', label: '战争片' },
    { href: '/category/documentary', label: '纪录片' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-accent-500"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                萝卜影视
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed max-w-xs">
              汇聚全球电影资源，提供高清流畅的在线观影体验。最新电影上线、热门电影排行榜，尽在萝卜影视。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速浏览
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.explore.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              电影类型
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              帮助与支持
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500/30 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50/70 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500/30 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50/70 text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-accent-500/30 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-50/70 text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 萝卜影视 luobo-movies.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}